import React, { useState } from "react";
import Button from "@mui/material/Button";
import CssBaseline from "@mui/material/CssBaseline";
import TextField from "@mui/material/TextField";
import Link from "@mui/material/Link";
import Paper from "@mui/material/Paper";
import Box from "@mui/material/Box";
import Grid from "@mui/material/Grid";
import Typography from "@mui/material/Typography";
import { makeStyles } from '@mui/styles';
// import axios from 'axios';
import axios from "../utils/axiosConfig";
import { WEB_URL } from "../utils/constants";
import LoaderProcessing from "../components/LoaderProcessing";
import ahGreenDotLogo from "../images/assesshub_logo_green_dot.svg";
import SupportBot from "./SupportBot";
import { useNavigate } from "react-router-dom";
import CheckCircleIcon from '@mui/icons-material/CheckCircle';

function Copyright() {
  return (
    <Typography variant="body2" color="textSecondary" align="center">
      {"Copyright © "}
      <Link color="inherit" href={WEB_URL}>
        AssessHub
      </Link>{" "}
      {new Date().getFullYear()}
      {"."}
    </Typography>
  );
}

const useStyles = makeStyles((theme) => ({
  root: {
    height: "100vh",
  },
  image: {
    backgroundImage: "url('./../../v2/images/login-page.svg')",
    backgroundRepeat: "no-repeat",
    backgroundColor: theme?.palette?.mode === "dark" ? theme?.palette?.grey?.[900] : theme?.palette?.grey?.[50] || '#fafafa',
    backgroundSize: "cover",
    backgroundPosition: "center",
  },
  paper: {
    padding: theme?.spacing?.(8, 4) || '64px 32px',
    display: "flex",
    flexDirection: "column",
    justifyContent: "center",
    alignItems: "center",
    minHeight: "100%",
    boxSizing: "border-box",
    // Mobile responsive padding
    '@media (max-width: 600px)': {
      padding: '40px 20px',
    },
    '@media (max-width: 400px)': {
      padding: '24px 16px',
    },
  },
  avatar: {
    margin: theme?.spacing?.(1) || '8px',
    backgroundColor: theme?.palette?.secondary?.main || '#dc004e',
  },
  form: {
    width: "100%", // Fix IE 11 issue.
    maxWidth: "400px",
    marginTop: theme?.spacing?.(3) || '24px',
    padding: '0 8px',
    boxSizing: 'border-box',
  },
  submit: {
    margin: theme?.spacing?.(3, 0, 2) || '24px 0 16px',
    minHeight: '48px', // Touch-friendly button height
    fontSize: '1rem',
  },
  logo: {
    maxWidth: "100%",
    width: "450px",
    maxHeight: "70px",
    objectFit: "contain",
    '@media (max-width: 400px)': {
      width: '280px',
      maxHeight: '50px',
    },
  },
  successIcon: {
    color: "#4caf50",
  },
  errorIcon: {
    color: "#f44336",
  },
}));

export default function ForgotPassword() {
  const classes = useStyles();
  let [email, setEmail] = useState("");
  let [success, setSuccess] = useState(false)
  let [errorMsg, setError] = useState("");
  // eslint-disable-next-line unused-imports/no-unused-vars
  const [loading, setLoading] = React.useState(false);

  const navigate = useNavigate()

  const handleSubmit = async (event) => {
    event.preventDefault();

    if (!email) {
      setError('Please enter your email address')
      return
    }

    // Basic email validation
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/
    if (!emailRegex.test(email)) {
      setError('Please enter a valid email address')
      return
    }

    setLoading(true);
    setError("");

    axios
      .post("/forgot-password", {
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
          Origin: "*",
          "Access-Control-Allow-Headers": "*",
          "Access-Control-Allow-Origin": "*",
        },
        userName: email.toLowerCase(),
      })
      .then((response) => {
        setLoading(false);

        if (response.data.success) {
          setSuccess(true)
        } else {
          setError(response.data.error || "Something went wrong.");
        }
      })
      .catch((error) => {
        setLoading(false);
        //, error.response.data
        setError(error.response.data.error);
      });
  };

  return (
    <>
      {" "}
      <Grid container component="main" id="main-body-two" className={classes.root}>
        <CssBaseline />
        <Grid item xs={false} sm={4} md={7} className={classes.image} />
        <Grid item xs={12} sm={8} md={5} component={Paper} elevation={6} square>
          <div className={classes.paper}>
            <img className={`img-responsive center-block ${classes.logo}`} src={ahGreenDotLogo} alt="React Logo" />
            {success ? (
              <div style={{ textAlign: "center" }}>
                <CheckCircleIcon style={{ fontSize: "80px", marginTop: "20px" }} className={`${classes.successIcon}`} />
                <div style={{ marginTop: "20px", paddingLeft: "20px" }}>
                  Password reset link has been sent to your email. Please check your inbox and follow the instructions.
                </div>
                <div style={{ width: "100%", textAlign: "center", marginTop: "20px", color: "rgb(123,96,176)", cursor: "pointer" }} onClick={() => navigate(-1)}>
                  &lt;&nbsp;&nbsp; Back to Login
                </div>
              </div>
            ) : (
              <form className={classes.form} onSubmit={handleSubmit} noValidate>
                <div>
                  Enter your email and we'll send you instructions to reset your password.
                </div>
                <TextField
                  variant="outlined"
                  margin="normal"
                  required
                  fullWidth
                  id="email"
                  label="Email"
                  name="email"
                  autoComplete="email"
                  value={email}
                  onChange={(event) => setEmail(event.target.value.toLowerCase())}
                />
                <Typography style={{ color: "red" }}>{errorMsg}</Typography>

                {loading ? (
                  <div className="loaderProcess" style={{ margin: "24px 0px 16px" }}>
                    <LoaderProcessing />
                  </div>
                ) : (
                  <Button type="submit" fullWidth variant="contained" color="primary" className={classes.submit}>
                    Send Reset Link
                  </Button>
                )}
                <div style={{ width: "100%", textAlign: "center", marginTop: "20px", color: "rgb(123,96,176)", cursor: "pointer" }} onClick={() => navigate(-1)}>
                  &lt;&nbsp;&nbsp; Back to Login
                </div>
                <Box mt={5}>
                  <Copyright />
                </Box>
              </form>
            )}
          </div>
        </Grid>
      </Grid>
      <SupportBot />
    </>
  );
}
